import WeatherPreview from "./WeatherPreview";
import { HourlyWeather, WeatherState } from "./WeatherUtils";
import { PopupContainer } from "../../../Popup/styled";
import styled from "styled-components";
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line, ReferenceLine } from "recharts";
import { useContext } from "react";
import { GameContext } from "../../../../contexts/GameContext";
import { addMinutes, displayTime, stringToTimeInterface } from "../../../../interface/Time";
import WeatherToolTip from "./WeatherToolTip";


interface Props {
    previsions: HourlyWeather[]
}


const WeatherPreviewPopup = ({ previsions }: Props) => {
    const { tempExt, weatherIdx, beginTime, endTime, round, maxRound, stepDuration, time, currentStep } = useContext(GameContext);

    function getData() {
        const res: { x: string; value: number; weather: WeatherState }[] = [];

        const nSteps = weatherIdx[round].length;
        const defaultTime = {hours:7,minutes:0}
        // Add current time to begin of next day.
        console.log(round, nSteps)
        for(let i=0;i<nSteps;i++) {
            const targetTime = addMinutes(defaultTime, i * stepDuration);
            const temp = tempExt[round][i];
            const weather = weatherIdx[round][i];

            if (targetTime.hours >= 24) {
                targetTime.hours -= 24;
            }

            res.push({
                x: displayTime(targetTime),
                value: temp,
                weather: weather
            });

        }

        // Add temp of next day
        // i = 0;
        // if (round + 1 < maxRound) {
        //     while (i < currentStep) {
        //         const targetTime = addMinutes(beginTime[round + 1], i * stepDuration);
        //         const temp = tempExt[round + 1][i];
        //         const weather = weatherIdx[round + 1][i];

        //         res.push({
        //             x: displayTime(targetTime),
        //             value: temp,
        //             weather: weather
        //         });

        //         ++i;
        //     }
        // }

        return res;
    }

    function getTicks() {
        const ticks: string[] = [];

        const graphData = getData();
        graphData.forEach((obj) => {
            if (stringToTimeInterface(obj.x).minutes === 0) {
                ticks.push(obj.x);
            }

        });

        return ticks
    }

    function getWeatherPrevisions() {
        const weatherPrevisions: WeatherState[] = [];
        const stepsPerHour = Math.floor(60.0 / stepDuration);

        for (let i = 0; i < weatherIdx[round].length / stepsPerHour; ++i) {
            weatherPrevisions.push(weatherIdx[round][i * stepsPerHour]);
        }

        return weatherPrevisions;
    }

    function showTime(idx: number) {
        const rawTime = addMinutes(beginTime[round], 60 * idx);

        return rawTime.hours >= 24 ? { hours: rawTime.hours - 24, minutes: rawTime.minutes } : rawTime
    }

    return (
        <PopupContainer>
            <div style={{ "width": "100%", "minWidth": "60vw" }}>
                {/*
                <SliderWrapper>
                    {getWeatherPrevisions().map((weatherState, idx) =>
                        <WeatherPreview
                            weatherState={weatherState}
                            time={showTime(idx)}
                            tempExt={tempExt[round][idx * 60 / stepDuration]}
                            key={idx} />
                    )}
                </SliderWrapper>
                */}
                <ResponsiveContainer width={"100%"} height={400}>
                    <LineChart
                        width={500}
                        height={400}
                        data={getData()}
                        margin={{
                            top: 20,
                            right: 20,
                            left: 20,
                            bottom: 20,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="x" label={{ value: 'Heure', position: 'insideBottom', offset: -10, style: { fontWeight: "bold" } }} ticks={getTicks()} offset={10} />
                        <YAxis dataKey="value" label={{ value: 'Température', position: 'insideLeft', angle: -90, offset: -10, style: { fontWeight: "bold" } }} unit={"°C"} />
                        <Tooltip content={<WeatherToolTip />} />
                        <Line name="Température (°C)" type="monotone" dot={false} dataKey="value" stroke="#8884d8" activeDot={{ r: 8 }} />
                        <ReferenceLine x={"07:00"} label={{ value: 'Heure', position: 'top', offset: 10, style: { fontStyle: "italic" } }} />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </PopupContainer>
    );
};


const SliderWrapper = styled.div`
  position: relative;
  display: flex;
  overflow: auto;
  margin-bottom: 20px;
`;


export default WeatherPreviewPopup;